export default __webpack_public_path__ + "static/media/No Equipment Needed.8ab54170.png";